import type React from 'react';

type DefaultLayoutProps = {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  navbar: React.ReactNode;
};

export const PageLayout = ({
  children,
  sidebar,
  navbar,
}: DefaultLayoutProps) => {
  return (
    <div className="h-full w-full overflow-hidden flex flex-col">
      {navbar}
      <div className="flex-auto flex overflow-hidden">
        {sidebar}
        <div className="flex-auto relative overflow-hidden">{children}</div>
      </div>
    </div>
  );
};
